import React from "react";
import { Row, Col } from "antd";
import Img from "../../image/donation/donation.png";
import {  Where_donation } from "../../Data/E_Offer";

const Where= () => {
  return (
       <section  className="extra-effort py-[80px] px-[1rem]">
      <div className="container m-auto">
        <Row
          gutter={[24, 24]}
          align="middle"
          justify="center"
          className="overflow-hidden"
        >
          {/* Left: Image */}
                  

          <Col xs={24} sm={24} md={12} lg={12} xl={12}>
            <div  className="banner-text">
                <h4 className="font-outfit text-sm  md:text-base text-[#555]">
               Transparent Impact
               </h4> 
              <h2 className="text-[40px] lg:text-[60px] font-cinzel text-start">
               Where Your <br /> Donation Goes
              </h2>
              <p className="pb-5 text-[18px] text-[#000] text-start font-outfit ">
              We believe trust is built through clarity. Lightweave Beacon Legacy uses donations responsibly to maximize benefit to artists and the creative ecosystem.
              </p>
               <div className="mt-[1rem]">
                   {Where_donation.map((data,index)=>(
                      <div key={index} className="flex flex-col gap-[9px] gap-[10px] mt-[0.8rem]">
                         <h2 className="font-cinzel text-[22px]">{data.title}</h2>
                         <p className="font-outfit text-[18px]">{data.detail}</p>
                      </div>
                   ))}
               </div>
             
            </div>
             {/* Right: Text */}
          </Col>
           <Col xs={24} sm={24} md={12} lg={12} xl={12}>
            <div  className="mission-images">
              <img
                src={Img}
                className="w-[100%] lg:w-[90%]  h-[90%] object-contain rounded-lg "
                alt="img"
              />
            </div>
          </Col>
        </Row>
      </div>
    </section>
  )
}

export default Where
